import { render } from "./ErrorBlock.vue?vue&type=template&id=e6ce519a&scoped=true&ts=true"
import script from "./ErrorBlock.vue?vue&type=script&lang=ts"
export * from "./ErrorBlock.vue?vue&type=script&lang=ts"

import "./ErrorBlock.vue?vue&type=style&index=0&id=e6ce519a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6ce519a"]])

export default __exports__